import React, {useEffect, useState} from 'react';
import {
    Box,
} from "@material-ui/core";
import RenderInput from "./RenderInput";

const TrafficSourceOfferInput = ({item, handleSwitchChange, handleInputChange, data, setInputs, inputs, value, disabled, advertiserId, offerId}) => {
    const [selectedAdvertiserId, setSelectedAdvertiserId] = useState('');
    const [selectedOfferId, setSelectedOfferId] = useState('');
    const [allOffersByAdvertiser, setAllOffersByAdvertisers] = useState({});
    const [availableOffers, setAvailableOffers] = useState([]);
    const [adverstiserWithOffers, setAdverstiserWithOffers] = useState([]);
    const [targetOfferUrlId, setTargetOfferUrlId] = useState('');
    const [availableOfferUrls, setAvailableOfferUrls] = useState([]);

    useEffect(() => {
        if(data) {
            const currentTargetOfferUrlId = data && data.trafficSource ? data.trafficSource.targetOfferUrlId : null;

            if (currentTargetOfferUrlId) {
                setTargetOfferUrlId(currentTargetOfferUrlId);
            }

            const currentOfferId = offerId ? offerId : data.trafficSource ? data.trafficSource.offer.id : null;

            if (currentOfferId) {
                setSelectedOfferId(currentOfferId);
                data.allOffer.forEach((offer) => {
                    if (offer.id === selectedOfferId) {
                        setAvailableOfferUrls(offer.offerUrls);
                    }
                });
                const selectedAdv = data.allOffer.filter(item => item.id === currentOfferId);
                if (selectedAdv.length) {
                    setSelectedAdvertiserId(selectedAdv[0].advertiserId);
                }
            }

            const offersByAdvertiser = {};
            data.allOffer.forEach((offer) => {
                if(offersByAdvertiser[offer.advertiserId]) {
                    offersByAdvertiser[offer.advertiserId].push(offer)
                } else {
                    offersByAdvertiser[offer.advertiserId] = [offer]
                }
            })
            setAllOffersByAdvertisers(offersByAdvertiser)
            const arr = [];
            data.allAdvertiser.forEach((adv) => {
                if (offersByAdvertiser[adv.id]) {
                    arr.push(adv);
                }
            });
            arr.sort((a, b) => a.name.localeCompare(b.name))
            setAdverstiserWithOffers(arr);
        }
    }, [data]);

    useEffect(() => {
        if (selectedOfferId) {
            setInputs({
                ...inputs,
                ["offerId"]: selectedOfferId
            });
            data.allOffer.forEach((offer) => {
                if (offer.id === selectedOfferId) {
                    setAvailableOfferUrls(offer.offerUrls);
                }
            });
        }
    }, [selectedOfferId])

    useEffect(() => {
        if (targetOfferUrlId) {
            setInputs({
                ...inputs,
                ["targetOfferUrlId"]: targetOfferUrlId
            });
        }
    }, [targetOfferUrlId])

    useEffect(() => {
        if (selectedAdvertiserId) {
            const arr = allOffersByAdvertiser[selectedAdvertiserId]
            if(arr){
                arr.sort((a, b) => a.offerName.localeCompare(b.offerName))
            }
            setAvailableOffers(arr)
        }
    }, [selectedAdvertiserId])

    if (!data) {
        return null
    }

    return (
        <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-around"}
            flexDirection={"column"}
            style={{width: '100%' }}
        >
            <Box width={'100%'} style={{ marginBottom: '20px' }}>
                <RenderInput
                    item={{
                        ...item,
                        label: 'Advertiser',
                        type: 'autoCompleteByKey',
                        displayKey: 'name',
                        returnKey: 'id',
                        required: item ? item.required : false,
                        val: "allAdvertiser",
                        key: "advertiser",
                        options: adverstiserWithOffers
                    }}
                    disabled={disabled}
                    value={selectedAdvertiserId}
                    data={data}
                    handleFilterChange={(value) => {
                        if (value) {
                            setSelectedAdvertiserId(value);
                        }
                    }}
                />
            </Box>
            <Box width={'100%'} style={{ marginBottom: '20px' }}>
                <RenderInput
                    item={{
                        ...item,
                        label: "Offer",
                        type: 'autoCompleteByKey',
                        required: item ? item.required : false,
                        displayKey: 'offerName',
                        returnKey: 'id',
                        options: availableOffers ? availableOffers.map((offer) => {
                           return {
                                id: (offer.offerId ? offer.offerId : offer.id),
                                ...offer
                            }
                        }) : [],
                        key: "offerId",
                        val: 'allOffer'
                    }}
                    data={data}
                    value={{id: selectedOfferId}}
                    handleFilterChange={(value) => {
                        if (value) {
                            setSelectedOfferId(value);
                        }
                    }}
                    handleInputChange={handleInputChange}
                    handleSwitchChange={handleSwitchChange}
                    disabled={!selectedAdvertiserId || disabled}
                />
            </Box>
            <Box width={'100%'}>
                <RenderInput
                    item={{
                        ...item,
                        label: "Target Offer Url",
                        type: 'autoCompleteByKey',
                        required: false,
                        displayKey: 'name',
                        returnKey: 'id',
                        options: availableOfferUrls,
                        key: "id"
                    }}
                    data={data}
                    value={{id: targetOfferUrlId}}
                    handleFilterChange={(value) => {
                        if (value) {
                            setTargetOfferUrlId(value);
                        }
                    }}
                    handleInputChange={handleInputChange}
                    handleSwitchChange={handleSwitchChange}
                    disabled={!selectedOfferId || disabled}
                />
            </Box>
        </Box>
    );
};

export default TrafficSourceOfferInput;
